export default __webpack_public_path__ + "static/media/fire-protection.77132729.png";